import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 260;
const HEIGHT = 125.439;

export const WeokieBannerWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 260 125.439"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="WEOKIE W watermark" opacity="0.08">
      <path id="Vector" d="M139.579 93.9649H140.035C142.088 80.7368 144.825 65.9123 148.018 50.8596L158.053 1.82456C146.649 1.82456 135.018 1.82456 123.386 1.59649L132.281 51.3158C135.018 65.9123 137.526 81.6491 139.579 93.9649Z" fill="white"/>
      <path id="Vector_2" d="M203.895 93.5088H204.351C206.175 79.8246 208.912 65.4561 211.421 50.8596L221.228 1.82456C211.649 1.82456 200.246 1.82456 187.93 1.82456L197.509 52.4561C200.246 66.8246 202.07 79.8246 203.895 93.5088Z" fill="white"/>
      <path id="Vector_3" d="M0 1.36842C0.22807 4.33333 0 20.0702 0 20.0702H90.5439V90.5439L118.14 104.228L93.7368 1.59649C43.1053 1.59649 0 1.36842 0 1.36842Z" fill="white"/>
      <path id="Vector_4" d="M171.965 32.8421H171.509C169.228 46.5263 167.404 58.1579 164.439 70.4737L154.632 115.632L187.018 117.912L177.667 70.4737C175.386 58.1579 173.333 46.7544 171.965 32.8421Z" fill="white"/>
      <path id="Vector_5" d="M257.947 61.5789V1.36842C257.719 1.59649 251.105 1.59649 249.281 1.59649L219.86 115.86L256.579 125.211L257.947 61.5789Z" fill="white"/>
      </g>
    </svg>
  );
};
